import { createRouteRef } from '@backstage/core-plugin-api';

/**
 * Root route ref for the v3 deploy plugin.
 *
 * Lives here (frontend) and NOT in deploy-v3-common because
 * `createRouteRef` imports from `@backstage/core-plugin-api`, a React-coupled
 * dependency. Putting it in -common would violate Rule 14 / Practice D2
 * (common package: zero runtime dependencies).
 */
export const rootRouteRef = createRouteRef({
  id: 'plugin.deploy-v3.root',
});
